export const CONVERSATION_EVENTS = {
    ADDED: 'conversation:added',
    READ: 'conversation:read',
    REMOVED: 'conversation:removed',
};

export const LINK_EVENTS = {
    CANCELLED: 'link:cancelled',
    FAILED: 'link:failed',
    MATCHED: 'link:matched',
};

export const PARTICIPANT_EVENTS = {
    ADDED: 'participant:added',
    REMOVED: 'participant:removed',
};

export const TYPING_EVENTS = {
    START: 'typing:start',
    STOP: 'typing:stop',
};

export const UPLOAD_EVENTS = {
    FAILED: 'upload:failed',
};
